import { useCallback, useEffect, useState } from 'react';
import { BrowserMultiFormatReader, NotFoundException } from '@zxing/library';
import ScanPortal from './scanPop';

const codeReader = new BrowserMultiFormatReader();

const useScanPage = (scanCallback) => {
  const [equipmentOpen, setEquipmentOpen] = useState(false);

  const scanEquipmentOpenHandler = (open) => () => setEquipmentOpen(open);

  const openScanPage = async () => {
    try {
      const videoInputDevices = await codeReader.listVideoInputDevices();
      if (videoInputDevices) {
        setEquipmentOpen(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return [
    () => equipmentOpen && <ScanPortal onClose={scanEquipmentOpenHandler(false)} scanCallback={scanCallback} />,
    openScanPage,
  ];
};

export { useScanPage };

const useScanQrcode = (scanCallback) => {
  const [cameraPermission, setCameraPermission] = useState('');

  const getStream = useCallback(async () => {
    try {
      return await navigator.mediaDevices.getUserMedia({
        audio: false,
        video: {
          facingMode: 'environment',
        },
      });
    } catch (error) {
      console.log(error);
    }
  }, []);

  const startScan = useCallback(async () => {
    try {
      const stream = await getStream();

      if (!stream) {
        setCameraPermission('fail');
        return;
      }

      await codeReader.decodeFromStream(stream, 'scanQrcodeVideo', (result, err) => {
        if (result) {
          setCameraPermission('finish');
          scanCallback(result.text);
        }
        if (err && !(err instanceof NotFoundException)) {
          console.error(err);
        }
      });

      setCameraPermission('success');
    } catch (error) {
      console.log(error);
    }
  }, [scanCallback]);

  useEffect(() => {
    setCameraPermission('');
    (async () => {
      await startScan();
    })();
    return () => codeReader.reset();
  }, []);

  return [cameraPermission];
};

export default useScanQrcode;
